import React, {useState} from 'react';
import {connect} from 'react-redux';
import uploadFile from '../../../../../../../../utils/FileService';
import Translate from '../../../../../../../../components/Translate';
import FileUpload from '../../../../../../../../components-new/general/FileUpload';
import SilverButton from '../../../../../../../../components-new/buttons/SilverButton';
import {addNotification} from '../../../../../../../../services/notification/action';
import config from '../../../../../../../../config';

function LogoUpload({logoUrl, onSave, background, addNotification}) {
    const [busy, setBusy] = useState(false);
    const save = async (file) => {
        if (busy) return;
        if (file && (!['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'].includes(file.type) || file.size > 2 * 1024 * 1024)) {
            addNotification('webChatLogoInvalid', config.notificationLevels.error);
            return;
        }
        setBusy(true);
        try {
            let url = null;
            if (file) {
                const data = new FormData();
                data.append('file', file);
                url = await uploadFile(data);
            }
            await onSave({logoUrl: url});
            addNotification('webChatLogoSaved', config.notificationLevels.success);
        } catch (error) {
            addNotification('webChatLogoFailed', config.notificationLevels.error);
        } finally {
            setBusy(false);
        }
    };
    return (
        <section className="wc-logo">
            <div className="wc-logo__actions">
                <div className="wc-logo__upload" aria-busy={busy}
                 style={{pointerEvents: busy ? 'none' : undefined}}>
                <FileUpload windowSize={76} imgSize={56} svgSize={28} progressSize={56}
                            image={logoUrl} uploadOnSelect={false} handleChange={save}
                            style={{background, borderRadius: '50%'}}/>
                </div>
                {/* disabled rather than hidden, so the section keeps its height */}
                <SilverButton type="button" size="sm" width="auto" disabled={busy || !logoUrl}
                              onClick={() => save(null)}>
                    <Translate text="webChatLogoReset"/>
                </SilverButton>
            </div>
            <div className="wc-logo__controls">
                <h2 className="stg-card__title"><Translate text="webChatLogo"/></h2>
                <p className="stg-card__note"><Translate text="webChatLogoHint"/></p>
                <div role="status" aria-live="polite" className="wc-logo__status">
                    {busy && <Translate text="webChatLogoSaving"/>}
                </div>
            </div>
        </section>
    );
}

export default connect(null, {addNotification})(LogoUpload);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/webChatDesignAndConfig/components/LogoUpload.jsx